export default "__VITE_ASSET__gEK_fxfJ__"